import React from 'react';
import styled from 'styled-components';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { AspectRatioContainer, AspectRatio } from '../../../components-core/packages/components-core/dist/aspect-ratio-container';

//STYLE
import { Text, TextAppearance, TextColor} from '../../../components-core/packages/components-core/dist/text';
import { Image } from '../../../components-core/packages/components-core/dist/image';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button';

//ICONS
import { Close } from '../../../components-core/packages/icons-core/dist/Close';


const Row = styled.tr`
    border: none;
    width: 100%;
`;

const Cell = styled.td`
    border-left: ${props => props.borderLeft ? '1px solid #ececec' : 'none'};
    @media (max-width: 768px) {
        &:nth-child(4), &:nth-child(3) {
            display: none;
        }
    }
`;

const Table = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
`;

const ClickableDiv = styled.div`
    cursor: pointer;
`;



class ModelComparisonHead extends React.Component {

    renderModels() {
        return dataListModel.map((data, index) => 
            <Cell borderLeft={index !== 0 ? true: false} >
                <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0050} >
                    <Container horizontalAlign={ContainerHorizontalAlignment.flexEnd}>
                        <ClickableDiv onClick={() => this.props.onDeleteClick(index)}>
                            <Close variant={'small'}/>
                        </ClickableDiv>
                    </Container>
                    <AspectRatioContainer ratio={AspectRatio['3:2']}>
                        <Image src={'https://picsum.photos/200/300'} alt={data.title} />
                    </AspectRatioContainer>

                    <Container wrap={ContainerWrap.always} padding={{ left: ContainerPadding.dynamic0050}} >
                        <Text appearance={TextAppearance.copy0200} bold>{data.title} </Text>
                        <Text appearance={TextAppearance.copy0150} bold>
                            Fiyatlar
                            <Text bold={false} color={TextColor.secondary}>{"'den başlayan fiyatlarla"} </Text>
                        </Text>
                    </Container>
                </Container>
            </Cell>
        )
    }

    renderEmptySlots() {
        const renderedEmptySlots = [];

        for (let i = dataListModel.length; i < 4; i++) {

            renderedEmptySlots.push(
                <Cell borderLeft={i !== 0 ? true: false}>
                    <Container horizontalAlign={ContainerHorizontalAlignment.center} >
                        <Button appearance={ButtonAppearance.Primary} onClick={() => this.props.onClick()}>
                            Model Ekle
                        </Button>
                    </Container>
                </Cell>
            )
        }

        return renderedEmptySlots;
    }

    render() {
        return (
            <Container 
                wrap={ContainerWrap.never} 
                padding={containerPadding} 
                stretchContent
            >
                <Table>
                    <Row>
                        {this.renderModels()}
                        {this.renderEmptySlots()}
                    </Row>
                </Table>
            </Container>
        )
    }
}

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid001,
        [Breakpoints.b1600]: ContainerPadding.grid002
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid001,
        [Breakpoints.b1600]: ContainerPadding.grid002
    }
}

const dataListModel = [
    {
        'title': 'Caddy',
    },
    {
        'title': 'Transporter',
    },
    {
        'title': 'Amarok',
    },
]

export default ModelComparisonHead;